
import Home                      from '../../pages/home';
import Program                   from '../../pages/programPage';
import Introduction              from '../../pages/introduction';
import CovidData                 from '../../pages/covidData';
import Gallery                   from '../../pages/gallery';
import Report                    from '../../pages/report';
import BirthRegistration         from '../../pages/birthregistration';
import Welcome                   from '../../pages/welcome';
import SignIn                    from '../../pages/admin/admin';
import Dashboard                 from './../../pages/admin/dashboard';
import DeathRegistrationForm     from './../admin/DeathRegistration/deathRegistrationForm';
import MarriageRegistrationForm  from '../admin/marriageRegistration/marriageRegistrationForm';
import MigrationRegistrationForm from './../admin/migration/migrationRegistrationForm';
import HouseRegistration         from '../admin/HouseRegistration/houseRegistration';
import Notice                    from '../../pages/notice';


export const HomeCom=()=><Home/>
export const ProgramCom=()=><Program/>
export const IntroductionCom=()=><Introduction/>
export const CovidDataCom=()=><CovidData/>
export const GalleryCom=()=> <Gallery/>
export const BirthRegistrationCom=()=><BirthRegistration/>

export const ReportCom=()=><Report/>
export const WelcomeCom=()=><Welcome/>
export const SignInCom=()=><SignIn/>
export const DashboardCom=()=><Dashboard/>
export const DeathRegistrationFormCom=()=><DeathRegistrationForm/>
export const MarriageRegistrationFormCom=()=><MarriageRegistrationForm/>
export const MigrationRegistrationFormCom=()=><MigrationRegistrationForm/>
export const HouseRegistrationCom=()=><HouseRegistration/>
export const NoticeCom=()=><Notice/>










